export const HERO_BG_BASE = '#020c1f';
export const HERO_BG_GRADIENT =
	'linear-gradient(145deg, #020c1f 0%, #0a2247 45%, #0d3d5c 100%)';

export const PILLAR_GLOW = {
	email: 'rgba(34, 211, 238, 0.18)',
	crm: 'rgba(168, 85, 247, 0.16)',
	projects: 'rgba(251, 146, 60, 0.16)',
	finance: 'rgba(52, 211, 153, 0.16)',
	ai: 'rgba(96, 165, 250, 0.18)',
};

export const PILLAR_ACCENT_HEX = {
	email: '#22d3ee',
	crm: '#a855f7',
	projects: '#fb923c',
	finance: '#34d399',
	ai: '#60a5fa',
};

export const SECTION_IDS = ['platform', 'blogsmith', 'workflow', 'pricing', 'testimonials', 'faq'];
